export const COUNTRIES = [
  ["CD", "République démocratique du Congo", "+243", ["Kinshasa", "Lubumbashi", "Goma", "Bukavu", "Matadi", "Kisangani", "Mbuji-Mayi", "Kananga"]],
  ["CG", "République du Congo", "+242", ["Brazzaville", "Pointe-Noire"]],
  ["AO", "Angola", "+244", ["Luanda", "Cabinda", "Lobito"]],
  ["BI", "Burundi", "+257", ["Bujumbura", "Gitega"]],
  ["RW", "Rwanda", "+250", ["Kigali", "Rubavu"]],
  ["UG", "Ouganda", "+256", ["Kampala", "Entebbe"]],
  ["KE", "Kenya", "+254", ["Nairobi", "Mombasa"]],
  ["TZ", "Tanzanie", "+255", ["Dar es Salaam", "Dodoma", "Arusha"]],
  ["ZA", "Afrique du Sud", "+27", ["Johannesburg", "Le Cap", "Durban", "Pretoria"]],
  ["CM", "Cameroun", "+237", ["Douala", "Yaoundé", "Bafoussam"]],
  ["CI", "Côte d’Ivoire", "+225", ["Abidjan", "Yamoussoukro", "Bouaké"]],
  ["SN", "Sénégal", "+221", ["Dakar", "Thiès", "Saint-Louis"]],
  ["GH", "Ghana", "+233", ["Accra", "Kumasi"]],
  ["NG", "Nigeria", "+234", ["Lagos", "Abuja", "Kano"]],
  ["BJ", "Bénin", "+229", ["Cotonou", "Porto-Novo"]],
  ["TG", "Togo", "+228", ["Lomé", "Sokodé"]],
  ["GA", "Gabon", "+241", ["Libreville", "Port-Gentil"]],
  ["GQ", "Guinée équatoriale", "+240", ["Malabo", "Bata"]],
  ["CF", "République centrafricaine", "+236", ["Bangui"]],
  ["TD", "Tchad", "+235", ["N’Djamena"]],
  ["ET", "Éthiopie", "+251", ["Addis-Abeba", "Dire Dawa"]],
  ["MA", "Maroc", "+212", ["Casablanca", "Rabat", "Marrakech"]],
  ["DZ", "Algérie", "+213", ["Alger", "Oran", "Constantine"]],
  ["TN", "Tunisie", "+216", ["Tunis", "Sfax"]],
  ["EG", "Égypte", "+20", ["Le Caire", "Alexandrie"]],
  ["FR", "France", "+33", ["Paris", "Lyon", "Marseille"]],
  ["BE", "Belgique", "+32", ["Bruxelles", "Anvers", "Liège"]],
  ["GB", "Royaume-Uni", "+44", ["Londres", "Manchester", "Birmingham"]],
  ["CA", "Canada", "+1", ["Montréal", "Toronto", "Ottawa"]],
  ["US", "États-Unis", "+1", ["New York", "Washington", "Atlanta"]],
  ["AE", "Émirats arabes unis", "+971", ["Dubaï", "Abou Dabi"]],
].map(([code, name, dial, cities]) => ({ code, name, dial, cities }));

export const DEFAULT_COUNTRY = COUNTRIES[0];
export const countryByCode = (code) => COUNTRIES.find((country) => country.code === code) || DEFAULT_COUNTRY;
